const angular = require('angular');

const HoverMenuService = require('./hovermenu.service');

angular.module('oly.common')
    .service('HoverMenuService', HoverMenuService)
    .directive('olyHoverMenu', require('./hovermenu.directive'))
    .directive('olyHoverMenuAction', ['$parse', require('./hovermenu-action.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/hovermenu/index.js